
const escapeRegExp = text => text.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');

const createRegExp = text => new RegExp(text && escapeRegExp(text), 'i');

export const search = {
  createRegExp,
};

